import { Flex } from '@chakra-ui/react';
import { useCustomersContext } from '../context';
import { useSearchParams } from 'react-router';
import { formatPhoneNumber } from '@utils/formats';
import FilterTag from '@components/FilterTag';

const PARAMS_LABELS = {
  name: 'Nome',
  email: 'E-mail',
  taxId: 'CPF',
  registration: 'Matrícula',
  tenure: 'Vínculo',
};

const SelectedFiltersList = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const tags = searchParams.get('tags')?.split(',') || [];
  const phoneNumbers = searchParams.get('phoneNumbers')?.split(',') || [];

  const params = Object.fromEntries(searchParams.entries());
  const paramsKeys = Object.keys(params).filter((key) => !['portfolioId', 'limit', 'page', 'tags', 'phoneNumbers'].includes(key));

  const { portfolioDetails } = useCustomersContext();

  const onRemoveFilter = (key: string, updatedValue?: string) => {
    const newParams = new URLSearchParams(searchParams);
    if (updatedValue) {
      newParams.set(key, updatedValue);
    } else {
      newParams.delete(key);
    }
    setSearchParams(newParams);
  };

  return (
    <Flex gap={2} flexWrap="wrap">
      {paramsKeys.map((key) => (
        <FilterTag
          key={key}
          label={PARAMS_LABELS[key as keyof typeof PARAMS_LABELS]}
          value={params[key]}
          onRemove={() => onRemoveFilter(key)}
        />
      ))}
      {portfolioDetails && params.portfolioId && (
        <FilterTag
          label="Portfólio"
          value={portfolioDetails.name}
          onRemove={() => onRemoveFilter('portfolioId')}
        />
      )}
      {tags.map((tag) => (
        <FilterTag
          key={tag}
          label="Tag"
          value={tag}
          onRemove={() => {
            const updated = tags.filter((t) => t !== tag);
            onRemoveFilter('tags', updated.length > 0 ? updated.join(',') : undefined);
          }}
        />
      ))}
      {phoneNumbers.map((phone) => (
        <FilterTag
          key={phone}
          label="Telefone"
          value={formatPhoneNumber(phone)}
          onRemove={() => {
            const updated = phoneNumbers.filter((p) => p !== phone);
            onRemoveFilter('phoneNumbers', updated.length > 0 ? updated.join(',') : undefined);
          }}
        />
      ))}
    </Flex>
  )
};

export default SelectedFiltersList;
